import { useMemo } from 'react';
import { TransitionType } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Animations/Transitions/Transitions.types';
import { TransitionConfig } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Animations/Transitions/Transitions.constants';
import { TransitionIconMap } from '@/App/remotion/libs/transitionIcons';
import SelectDropdownV2 from '@/components/atoms/SelectDropdownV2';
import { classnames } from '@/libs/utils';
import Icon from '@/components/atoms/Icon';

const iconSize = 16;

export const TransitionTypeDropdown = ({
  selected,
  onChange,
  disabled
}: {
  selected: TransitionType | null;
  onChange: (selected: TransitionType | null) => void;
  disabled: boolean;
}) => {
  const options = useMemo(() => {
    return [
      { value: null, label: 'None', Icon: <Icon name="IconMinus" size={iconSize} className="text-slate-400" /> },
      ...Object.values(TransitionType).map((type: TransitionType) => {
        const iconName = TransitionIconMap[type];
        return {
          value: type,
          label: TransitionConfig[type].label,
          Icon: <Icon name={iconName} size={iconSize} className="text-slate-400" />
        };
      })
    ];
  }, []);

  return (
    <div className={classnames('mt-2.5 flex flex-1 flex-col', disabled ? 'cursor-not-allowed' : '')}>
      <SelectDropdownV2 options={options} selected={selected} onChange={onChange} disabled={disabled} />
    </div>
  );
};
